/*
 * File: client.service.tsx
 * Project: a-a
 * File Created: Thursday, 9th January 2025 9:44:20 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 7th October 2025 2:04:30 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { ClientActivityQueryParams, ClientTaskQueryParams } from '../model/client.model';
// import { ActivityQueryParams, TaskQueryParams } from '../model/dashboard.model';

import { ApiConstants } from './api-constants';
export class ClientService {
  static getAllClient = async () => {
    return await (
      await axios.get(ApiConstants.CLIENT_API.ALL_CLIENT.URL())
    ).data;
  };
  static getDealType = async () => {
    return await (
      await axios.get(ApiConstants.CLIENT_API.DEAL_TYPES.URL())
    ).data;
  };
  static getDealDropdown = async (id?: string) => {
    return await (
      await axios.get(ApiConstants.CLIENT_API.DEAL_DROPDOWN.URL(id))
    ).data;
  };
  static getPricebooks = async () => {
    return await (
      await axios.get(ApiConstants.CLIENT_API.ALL_PRICEBOOKS.URL())
    ).data;
  };
  static getPricebookProducts = async (id: string) => {
    return await (
      await axios.get(ApiConstants.CLIENT_API.PRICEBOOK_PRODUCTS.URL(id))
    ).data;
  };
  static addDeal = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.CLIENT_API.ADD_DEAL.URL(), payload)
    ).data;
  };
  static editDeal = async (id: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.CLIENT_API.EDIT_DEAL.URL(id), payload)
    ).data;
  };
  static deleteDeal = async (id: string, data: any) => {
    // console.log(data);
    return await (
      await axios.delete(ApiConstants.CLIENT_API.DELETE_DEAL.URL(id), data)
    ).data;
  };
  static addPricebookProducts = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.CLIENT_API.CREATE_PRICEBOOK_PRODUCTS.URL(), payload)
    ).data;
  };
  static editPricebookProducts = async (payload: any, id: string) => {
    return await (
      await axios.patch(ApiConstants.CLIENT_API.EDIT_PRICEBOOK_PRODUCTS.URL(id), payload)
    ).data;
  };
  static getCaptive8Info = async (id: string) => {
    return await (
      await axios.get(ApiConstants.CAPTIVE8_API.MAIN_INFO.URL(id))
    ).data;
  };
  static getCreatorInfo = async (id: string) => {
    return await (
      await axios.get(ApiConstants.CAPTIVE8_API.CREATOR.URL(id))
    ).data;
  };
  static getTasks = async (id: string, query: ClientTaskQueryParams) => {
    // console.log(ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.get(
        ApiConstants.CLIENT_API.CLIENT_TASKS.URL(id) +
          ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getActivity = async (id: string, query: ClientActivityQueryParams) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(
        ApiConstants.CLIENT_API.CLIENT_ACTIVITY.URL(id) +
          ApiConstants.CLIENT_API.CLIENT_ACTIVITY.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getClientDetails = async (id: string) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.CLIENT_API.CLIENT_DETAILS.URL(id))
    ).data;
  };
  static getClientContacts = async (id: string) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.CLIENT_API.CLIENT_CONTACTS.URL(id))
    ).data;
  };
  static getClientDeal = async (id: string) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.CLIENT_API.CLIENT_DEAL.URL(id))
    ).data;
  };
  static getClientKeyDeals = async (id: string, query: any) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(
        ApiConstants.CLIENT_API.CLIENT_KEY_DEALS.URL(id) +
          ApiConstants.CLIENT_API.CLIENT_ACTIVITY.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getClientDropdowns = async (id: string) => {
    // console.log(ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.get(ApiConstants.CLIENT_API.CLIENT_DROPDOWNS.URL(id))
    ).data;
  };
  static addClient = async (payload: any) => {
    // console.log(ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.post(ApiConstants.CLIENT_API.CLIENT_ADD.URL(), payload)
    ).data;
  };
  static deleteClient = async (id: string) => {
    // console.log(data);
    return await (
      await axios.delete(ApiConstants.CLIENT_API.DELETE_EDIT_CLIENT.URL(id))
    ).data;
  };
  static editClient = async (payload: any, id: string) => {
    // console.log(data);
    return await (
      await axios.patch(ApiConstants.CLIENT_API.DELETE_EDIT_CLIENT.URL(id), payload)
    ).data;
  };
  static searchCaptiv8 = async (user: string) => {
    return await (
      await axios.get(ApiConstants.CAPTIVE8_API.SEARCH_ID.URL(user))
    ).data;
  };
}
